module.exports = __webpack_public_path__ + "media/5.8fa0b4c4.mp3";